import { useLocale, useTranslations } from 'next-intl';
import { useSuspenseQuery } from '@apollo/client';
import { LocationListingsQuery } from '@/query';

import { AutoSizer } from 'react-virtualized';
import { ListingsListHeader } from '@/components/listings/ListHeader';
import { ListComponent } from '@/components/listings/List';

export const Page = ({ group, page, variables }) => {
  const t = useTranslations();
  const locale = useLocale();

  const { data, networkStatus } = useSuspenseQuery(LocationListingsQuery, {
    variables: {
      ...variables,
      locale,
      page,
    },
    errorPolicy: 'ignore',
  });

  const totalCount = data?.availableListings?.metadata?.totalCount || 0;
  const isFirst = networkStatus !== 1 && page === 1;

  const searchState = {
    date: {},
    location: group?.location || {},
  };

  const list = (
    <>
      {isFirst ? (
        <div className="container pb-6 pt-2 3xl:rounded-t-10">
          <ListingsListHeader tag="h2">
            {totalCount > 300 ? '300+' : `${totalCount}`}{' '}
            <span className="lowercase">{t('listings.result.title')}</span>
          </ListingsListHeader>
        </div>
      ) : null}
      {data?.availableListings?.collection?.length ? (
        <AutoSizer
          className="!w-full flex-1 flex flex-col"
          disableHeight={true}
          defaultWidth={640}
        >
          {({ width }) => (
            <div className="container flex flex-col min-h-full flex-1 lg:max-list-3xl:!px-[52px] sm:max-lg:!px-[28px]">
              <ListComponent
                initialData={data?.availableListings}
                width={width}
                disableScrollLoad
                limit={10}
                searchState={searchState}
                pageName="listing group"
              >
                {({ list }) => (list ? <div>{list}</div> : null)}
              </ListComponent>
            </div>
          )}
        </AutoSizer>
      ) : null}
    </>
  );

  return !totalCount ? null : isFirst ? (
    <section
      className={`container !px-0 max-sm:pt-7 pt-2 max-sm:pb-4 3xl:mb-3 3xl:rounded-10 3xl:overflow-hidden`}
    >
      {list}
    </section>
  ) : (
    list
  );
};
